module.exports = __webpack_public_path__ + "static/img/1.07d4d39d.png";